import { render } from "./menu.vue?vue&type=template&id=5ec8cf2f&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=5ec8cf2f&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=5ec8cf2f&lang=scss"
script.render = render
script.__scopeId = "data-v-5ec8cf2f"

export default script